import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadTempImageModal({ cancelModal, passDownData }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const [previewUrl, setPreviewUrl] = useState(null);
  //styled
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file)); // Create a preview URL for the selected image
    } else {
      setPreviewUrl(null);
    }
  };
  const fileUploadHandler = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    setIsLoading(true); // Start loading

    if (!selectedFile) return; // Don't proceed if no file selected

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/bookingProfile/ImageTemp`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setUploadSuccess(true); // Indicate the upload was successful
        passDownData(previewUrl); // Pass down the preview URL
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // Optionally, show an error message to the user or handle it further
    } finally {
      setIsLoading(false); // Reset the loading state after the request is complete
    }
  };
  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (uploadSuccess) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Image Uploaded</p>
            </div>
            <p>Image has been successfully uploaded.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  cancelModal();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <form onSubmit={fileUploadHandler}>
              {" "}
              {/* Attach submit handler */}
              <div className="send-modal-content">
                <div className="blueBanner">
                  <p className="fw-bold m-2 p-2 fontSize20">Upload Image</p>
                </div>
                <button
                  type="button"
                  className="close-button"
                  onClick={cancelModal}
                  aria-label="Close"
                >
                  &times;
                </button>
                <div>
                  <input type="file" onChange={handleFileChange} />
                  <button className="saveChanges-button" type="submit">
                    Upload
                  </button>{" "}
                  {/* Ensure button type is "submit" */}
                </div>
                {previewUrl && (
                  <img
                    src={previewUrl}
                    alt="Image Preview"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}{" "}
                {/* Display image preview */}
              </div>
              <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
}
